import createDOMPurify, {} from 'dompurify';
import { loadAllowlist, toDomPurifyConfig, } from '../sanitize/index.js';
const URL_ATTRIBUTES = new Set(['href', 'src']);
const FORCE_KEPT_ATTRIBUTES = new Set([
    'decoding',
    'loading',
    'referrerpolicy',
    'rel',
    'target',
]);
const DANGEROUS_STYLE_VALUE = /url\s*\(|expression\s*\(|javascript\s*:|data\s*:/iu;
const allowlist = loadAllowlist();
const config = toDomPurifyConfig(allowlist);
const DOMPurify = createDomPurify();
DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    const tagName = node.nodeName.toLowerCase();
    const attrName = data.attrName.toLowerCase();
    if (FORCE_KEPT_ATTRIBUTES.has(attrName)) {
        return;
    }
    if (!isAllowedAttribute(allowlist, tagName, attrName)) {
        data.keepAttr = false;
        return;
    }
    if (URL_ATTRIBUTES.has(attrName) && !isAllowedUrl(data.attrValue, allowlist)) {
        data.keepAttr = false;
        return;
    }
    if (attrName === 'style') {
        data.attrValue = filterStyle(data.attrValue, allowlist);
        data.keepAttr = data.attrValue.length > 0;
    }
});
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName === 'IMG') {
        node.setAttribute('loading', 'lazy');
        node.setAttribute('referrerpolicy', 'no-referrer');
        node.setAttribute('decoding', 'async');
    }
    if (node.nodeName === 'A' && node.hasAttribute('href')) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});
/**
 * 唯一富文本 HTML 注入前净化 seam。空值显式渲染为空字符串；配置错误、DOMPurify
 * 初始化错误均直接抛出，禁止 fallback 到原始 HTML 或 DOMPurify 默认配置。
 */
export function sanitizeRichText(html) {
    if (!html) {
        return '';
    }
    return DOMPurify.sanitize(html, config);
}
function createDomPurify() {
    if (!globalThis.window) {
        throw new Error('[RichText] DOMPurify requires a browser-like window; run RichText only in a DOM runtime.');
    }
    const purifier = createDOMPurify(globalThis.window);
    if (!purifier.isSupported) {
        throw new Error('[RichText] DOMPurify does not support the current DOM runtime.');
    }
    return purifier;
}
function isAllowedAttribute(config, tagName, attrName) {
    if (attrName.startsWith('on')) {
        return false;
    }
    return allowsAttribute(config.allowedAttributes['*'], attrName)
        || allowsAttribute(config.allowedAttributes[tagName], attrName);
}
function allowsAttribute(attrs, attrName) {
    if (!attrs) {
        return false;
    }
    return attrs.includes(attrName)
        || (attrName.startsWith('data-') && attrs.includes('data-*'));
}
function isAllowedUrl(value, config) {
    const trimmed = value.trim().replace(/[\u0000-\u001f\u007f\s]+/gu, '');
    const schemeMatch = /^([a-z][a-z0-9+.-]*):/iu.exec(trimmed);
    if (!schemeMatch) {
        return true;
    }
    const scheme = schemeMatch[1];
    if (!scheme) {
        return true;
    }
    return config.allowedSchemes.includes(scheme.toLowerCase());
}
function filterStyle(value, config) {
    return value
        .split(';')
        .map((declaration) => declaration.trim())
        .filter((declaration) => isAllowedStyleDeclaration(declaration, config))
        .join('; ');
}
function isAllowedStyleDeclaration(declaration, config) {
    const separator = declaration.indexOf(':');
    if (separator <= 0) {
        return false;
    }
    const property = declaration.slice(0, separator).trim().toLowerCase();
    const value = declaration.slice(separator + 1).trim();
    return config.allowedCssProperties.includes(property)
        && value.length > 0
        && !DANGEROUS_STYLE_VALUE.test(value);
}
//# sourceMappingURL=sanitize-rich-text.js.map